<template>
  <v-dialog v-model="openDialog" max-width="500" lazy>
    <v-card>
      <v-toolbar>
        <img class="align-center cursor-pointer"
             height="38" width="38"
             src="/static/Quickbooks-Logo.png"/>
        <v-toolbar-title>
          Simplify Accounting by Using Quickbooks
        </v-toolbar-title>
      </v-toolbar>
      <v-spacer/>
      <div class="pa-3">
        Did you know {{ $t('site-title') }} can create invoices and billable expenses in Quickbooks for you, without
        leaving this screen? Using all the details from the load created in the planner and the
        driver's status updates along the way, {{ $t('site-title') }} can export all the customer, origin,
        destination, and freight information.
      </div>
      <div class="pa-3">Check it out now by connecting to Quickbooks in your company's profile!
      </div>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="accent" flat
               @click="openDialog = false">
          Cancel
        </v-btn>
        <v-btn color="accent"
               :to="`/companies/${invoicingCompany.id}/profile#quickbooks`">
          Setup Quickbooks
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'InfoDialog',
  props: {
    value: {
      type: Boolean,
    },
    invoicingCompany: {
      type: Object,
    },
  },
  data() {
    return {
      openDialog: this.value,
    };
  },
  watch: {
    value() {
      this.openDialog = this.value;
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/qb/InfoDialog.vue